module.exports = __webpack_public_path__ + "img/match_logo_default.27fa142b.png";